  (function () {
    // 1. 核心更新进度条函数
    window.updateCartProgressBar = function (itemCount, cartTotal) {
      const fill = document.getElementById('cpb-fill');
      const message = document.getElementById('cpb-message');

      const msShip = document.getElementById('milestone-shipping');
      const ms10 = document.getElementById('milestone-10');
      const ms15 = document.getElementById('milestone-15');
      const ms20 = document.getElementById('milestone-20');

      if (!fill || !message) return;

      const FREE = 49.00;
      const OFF10 = 70.00;
      const OFF15 = 105.00;
      const OFF20 = 139.00;

      // 进度计算（基于原价总额）
      const progress = Math.min((cartTotal / OFF20) * 100, 100);
      fill.style.width = progress + '%';

      msShip?.classList.toggle('is-reached', cartTotal >= FREE);
      ms10?.classList.toggle('is-reached', cartTotal >= OFF10);
      ms15?.classList.toggle('is-reached', cartTotal >= OFF15);
      ms20?.classList.toggle('is-reached', cartTotal >= OFF20);

      let html = '';
      if (cartTotal < FREE) {
        const remaining = (FREE - cartTotal).toFixed(2);
        html = `You're <strong>$${remaining}</strong> away from <strong>Free Shipping</strong>.`;
      } else if (cartTotal < OFF10) {
        const remaining = (OFF10 - cartTotal).toFixed(2);
        html = `<strong>Free Shipping</strong> unlocked. Add <strong>$${remaining}</strong> more to unlock <strong>10% Off</strong>.`;
      } else if (cartTotal < OFF15) {
        const remaining = (OFF15 - cartTotal).toFixed(2);
        html = `<strong>10% Off</strong> unlocked. Add <strong>$${remaining}</strong> more to unlock <strong>15% Off</strong>.`;
      } else if (cartTotal < OFF20) {
        const remaining = (OFF20 - cartTotal).toFixed(2);
        html = `<strong>15% Off</strong> unlocked. Add <strong>$${remaining}</strong> more to unlock <strong>20% Off</strong>.`;
      } else {
        html = `<strong>20% Off</strong> unlocked. <strong>Free Shipping</strong> unlocked.`;
      }

      message.innerHTML = html;
    };

    // 2. 从页面直接抓取原价或总价的函数
    function refreshFromDOM() {
      const bar = document.getElementById('cart-progress-bar');
      if (!bar) return;

      // 优先看有没有实时更新的 data 属性，如果没有就去抓取后台的 cart.js 或者你可以直接在这里通过接口拿
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          let originalTotalCents = 0;
          if (cart.items && cart.items.length > 0) {
            cart.items.forEach(item => {
              originalTotalCents += (item.original_line_price || item.line_price);
            });
          } else {
            originalTotalCents = cart.total_price;
          }
          window.updateCartProgressBar(cart.item_count, originalTotalCents / 100.0);
        })
        .catch(err => console.log(err));
    }

    // 3. 终极绝招：使用 MutationObserver 监听整个网页或购物车区域的文字变化
    // 只要价格标签变了，进度条就立刻跟着刷新！
    const observerTarget = document.querySelector('body'); // 或者指定你的购物车容器
    if (observerTarget) {
      const observer = new MutationObserver((mutations) => {
        // 当 DOM 发生变动时，延迟 200ms 执行刷新，避免过于频繁
        clearTimeout(window._cartRefreshTimer);
        window._cartRefreshTimer = setTimeout(() => {
          refreshFromDOM();
        }, 200);
      });

      observer.observe(observerTarget, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    // 初始化运行一次
    refreshFromDOM();
  })();